import { makeChartComp } from '../../util/makeChartComp';
var StockChart = makeChartComp('Stock');
export default StockChart;
